

let currentPage = 1; 
const limit = 12;


function loadBlogPosts(page) {
  fetch(`https://skoutshonor-a6ffe07477d4.herokuapp.com/api/blog-posts?page=${page}&limit=${limit}`)
    .then((response) => response.json())
    .then((data) => {
      console.log('Blog posts:', data);

      const blogContainer = document.querySelector('.blog-articles'); 
      if (!blogContainer) {
        console.error('Not exist .blog-articles in the DOM.');
        return;
      }


      blogContainer.innerHTML = '';

      data.results.forEach((post) => {
        if (!post.featuredImage || !post.name || !post.url) {
          console.warn('Not properties post:', post);
          return;
        }

        const { featuredImage, name, url, metaDescription } = post;

        const blogItem = document.createElement('div');
        blogItem.className = 'blog-articles__article article scroll-trigger animate--slide-in';

        blogItem.innerHTML = `
        <div class="article-card-wrapper card-wrapper">
          <div class="
              card article-card
              card--standard
              article-card__image--large
              card--media" 
              style="--ratio-percent: 66.79358172423171%;">
            <div class="card__inner color-background-2 gradient ratio" 
                 style="--ratio-percent: 66.79358172423171%;">
              <div class="article-card__image-wrapper card__media">
                <div class="article-card__image media media--hover-effect">
                  <img 
                    src="${featuredImage}" 
                    sizes="(min-width: 1600px) 750px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)" 
                    alt="Keeping Your Dog Cool in High Summer Heat: Essential Tips and Tricks" 
                    class="motion-reduce" 
                    loading="lazy" 
                    width="3677" 
                    height="2456">
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h2">
                    <a href="${url}" target="_blank" class="full-unstyled-link">
                      ${name}...
                    </a>
                  </h3>
                  <div class="article-card__info caption-with-letter-spacing h5"></div>
                  <p class="article-card__excerpt rte-width">${metaDescription}...</p>
                  <div class="article-card__footer"></div>
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h2">
                  <a href="${url}"  target="_blank" class="full-unstyled-link">
                    ${name}...
                  </a>
                </h3>
                <div class="article-card__info caption-with-letter-spacing h5"></div>
                <p class="article-card__excerpt rte-width">${metaDescription}...</p>
                <div class="article-card__footer"></div>
              </div>
            </div>
          </div>
        </div>
      `;

        blogContainer.appendChild(blogItem);
      });

     
      handlePagination(data.total);
    })
    .catch((error) => console.error('Error fetching blog posts:', error));
}

function handlePagination(totalPosts) {
  const totalPages = Math.ceil(totalPosts / limit);

  const paginationList = document.querySelector('.pagination__list');
  if (!paginationList) {
    console.error('Pagination container not found');
    return;
  }
  paginationList.innerHTML = '';


  const prevItem = document.createElement('li');
  prevItem.innerHTML = `
    <a href="#" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" 
       aria-label="Previous page" ${currentPage === 1 ? 'aria-disabled="true"' : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <path d="M15.8307 10.8374H4.16406M4.16406 10.8374L9.9974 16.6707M4.16406 10.8374L9.9974 5.00403" 
              stroke="#44403C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
      Previous
    </a>`;
  prevItem.querySelector('a').onclick = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      currentPage--;
      loadBlogPosts(currentPage);
    }
  };
  paginationList.appendChild(prevItem);

  for (let i = 1; i <= totalPages; i++) {
    const pageItem = document.createElement('li');
    pageItem.innerHTML = `
      <a href="#" class="pagination__item ${i === currentPage ? 'pagination__item--current' : 'link'}" 
         aria-label="Page ${i}" ${i === currentPage ? 'aria-current="page"' : ''}>${i}</a>`;
    pageItem.querySelector('a').onclick = (e) => {
      e.preventDefault();
      currentPage = i;
      loadBlogPosts(currentPage);
    };
    paginationList.appendChild(pageItem);
  }


  const nextItem = document.createElement('li');
  nextItem.innerHTML = `
    <a href="#" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" 
       aria-label="Next page" ${currentPage === totalPages ? 'aria-disabled="true"' : ''}>
      Next
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <path d="M4.16406 10.8374H15.8307M15.8307 10.8374L9.9974 5.00403M15.8307 10.8374L9.9974 16.6707" 
              stroke="#44403C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </a>`;
  nextItem.querySelector('a').onclick = (e) => {
    e.preventDefault();
    if (currentPage < totalPages) {
      currentPage++;
      loadBlogPosts(currentPage);
    }
  };
  paginationList.appendChild(nextItem);
}


loadBlogPosts(currentPage);
